let initialized = false

export default (onLoadCallback: Function) => {
    if (initialized) {
        return false
    }

    useHead({
        script: [
            {
                type: 'text/javascript',
                src: 'https://client.smartform.cz/v2/smartform.js',
                async: true,
                onload: () => {
                    onLoadCallback()
                },
            },
        ],
    })
    initialized = true

    return true
}
